<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" size="small" v-if="list.headImgUrl" :src="list.headImgUrl"></el-avatar>
              <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box">
                <p>{{ list.nickName }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">{{ list.mobile ? '手机号码:' : '身份证号码:'}} {{ list.mobile ? list.mobile : list.idCardNo}}</p>
                  <p>可用余额: <span class="fontSize18">￥{{ list.walletAmount }}</span></p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="totals-box plr24 mt30">
            <div class="flex-row mb30">
              <div class="itemName">会员姓名</div>
              <div class="itemNum">{{ rows.customerName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">会员手机</div>
              <div class="itemNum">{{ rows.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">建档时间</div>
              <div class="itemNum">{{ formatDate(rows.recordTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">症状</div>
              <div class="itemNum">{{ rows.categoryName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">部位及数量</div>
              <div class="itemNum">{{ rows.symptom }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">已收金额</div>
              <div class="moneys">￥{{ rows.realPayAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>退款明细</i></p>
          <div class="totals-box plr24">
            <div class="flex-row mb30">
              <div class="itemName">退款金额</div>
              <el-input
                v-model.trim="form.refundAmount"
                placeholder="请输入退款金额"
                @input="changeRefundAmount"
                maxlength="8"
              ></el-input>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">扣除提成</div>
              <div class="itemNum moneys">￥{{ form.deductAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">扣除社保</div>
              <div class="itemNum moneys">￥{{ untio.totalSocialSubsidyAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">扣除技师</div>
              <div class="itemNum">{{ untio.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款类型</div>
              <el-radio-group v-model="form.refundReasonType">
                <el-radio label="customerRefund">客户退款</el-radio>
                <el-radio label="optFault">操作失误</el-radio>
              </el-radio-group>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">退款备注</div>
              <el-input type="textarea" v-model="form.remark" placeholder="请输入退款备注" maxlength="150" show-word-limit></el-input>
            </div>
          </div>
          <div class="tips">
            <p class="tips-title infos">温馨提示</p>
            <div class="hint" v-for="(item,index) in tips" :key="index">{{ item }}</div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pb10 pr24">
            <div class="btns_total">退款总金额：<span class="moneys">￥{{ form.refundAmount ? form.refundAmount : 0}}</span></div>
            <el-button type="primary" @click="save">确定申请</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <div class="refundDialog">
        <el-form
          ref="form"
          label-position="right"
          :model="form"
          label-width="100px"
        >
          <el-form-item label="退款总金额：">
            ￥{{form.refundAmount}}
          </el-form-item>
          <el-form-item label="本金退款：">
            ￥{{refundbaseAmount || 0}}
          </el-form-item>
          <el-form-item label="赠金退款：">
            ￥{{refundGiveAmount || 0}}
          </el-form-item>
          <el-form-item label="">
            <p class="red">请注意：退款后将不能继续登记</p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "档案退款",
      addEditShow: false,
      imgHide: false, //图片隐藏
      optionsHide: false,
      options: [],
      headerImg: require("../../../assets/images/headerImg.png"),
      untio: {},
      mobile: "",
      form: {
        refundType: "repair",
        repairDocId: "",
        refundAmount: "",
        deductAmount: 0,
        staffId: "",
        remark: "",
        memberId: "",
        refundItemList: [],
        refundReasonType: "",
      },
      staffIdList: [],
      staffNameList: [],
      rows: {},
      tips: {},
      list:{},
      dialogVisible: false,
      refundGiveAmount: 0,
      refundbaseAmount: 0,
    };
  },
  created() {
    this.editInit();
   
  },
  methods: {
    changeRefundAmount () {
      this.form.deductAmount = Number(this.form.refundAmount * this.untio.repairDeductRatio).toFixed(2);
      this.untio.totalSocialSubsidyAmount = Number(this.form.refundAmount * this.untio.repairSocialSubsidyRatio).toFixed(2);
      // let a = Number(this.rows.realPayAmount)
      // let b = Number(this.form.refundAmount)
      // let c = Number(this.untio.repairDeductRatio)
      // if (a == b) {
      //   this.form.deductAmount = this.untio.totalDeductAmount
      // } else {
      //   this.form.deductAmount = (b * c).toFixed(2);
      // }
    },
     getTips() {
      this.$api.get(this.$url.companyRefund.getTips, {type: "refundRepair"}).then(res => {
          if (res) {
            this.tips = res;
          }
        });
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.mobile = this.$store.getters.MemberMobile;
        this.addEditShow = true;
        this.rows = org;
        console.log(org);
        this.form.refundItemList = [
          {
            itemId: this.rows.id,
            itemType: "serve",
            itemAmount: this.rows.amount,
            itemNum: 1
          }
        ];
        this.form.staffId = org.staffId;
        this.form.repairDocId = org.id;
        this.form.memberId = org.memberId;
        this.form.payMemberId = org.payMemberId;
        if (org.refundReasonType) {
          this.form.refundReasonType = org.refundReasonType;
        }
        this.getDeductMsg();
        this.getMenber();
         this.getTips();
        // this.invoiceCategory();
      });
    },
    getMenber () {
      this.$api.get(this.$url.member.get, {
        id: this.form.payMemberId
      }).then(res => {
        if (res) {
          this.list = res;
        }
      })
    },  
    getDeductMsg() {
      this.$api
        .get(this.$url.companyRefund.getRepairDeductRatio, {
          orderId: this.rows.orderId
        })
        .then(res => {
          if (res) {
            this.untio = res;
            this.untio.totalSocialSubsidyAmount = 0;
            // this.form.deductAmount = this.rows.amount * res;
          }
        })
        .catch(error => {});
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    save() {
      if (!this.form.refundAmount) {
          this.$message.warning("请输入退款金额");
          return false;
      }
      if (isNaN(this.form.refundAmount)) {
          return this.$message.error("请输入数字类型")
      }
      if (this.form.refundAmount - this.rows.realPayAmount > 0) {
        this.$message.warning("退款金额不能大于已收金额");
        return false;
      }
      if (this.form.refundReasonType == "") {
        this.$message.warning("请选择退款类型");
        return false;
      }
      if (this.form.remark == "") {
        this.$message.warning("请输入退款备注");
        return false;
      }
      /** a 计算赠金比列 */
      this.dialogVisible = true;
      if (this.form.refundAmount == 0) return
      if (this.untio.basePayAmount == 0) {
        this.refundbaseAmount = 0;
        this.refundGiveAmount = this.form.refundAmount;
        return
      } else if (this.untio.givePayAmount == 0){
        this.refundbaseAmount = this.form.refundAmount;
        this.refundGiveAmount = 0;
        return
      }
      let a = (Number(this.form.refundAmount) / Number(this.rows.realPayAmount)).toFixed(4);
      this.refundbaseAmount = (a * Number(this.untio.basePayAmount)).toFixed(2);
      this.refundGiveAmount = (Number(this.form.refundAmount) - this.refundbaseAmount).toFixed(2);
      
      // this.$confirm('退款后将不能继续登记！确定要申请退款吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      //   center: true
      // }).then(() => {
      //   this.$api.post(this.$url.companyRefund.applyRepair, this.form).then(res => {
      //     if (res) {
      //       this.addEditShow = false;
      //       this.$message.success("操作成功");
      //       this.$emit("change", true);
      //     }
      //   })
      // })
    },
    confirm () {
      this.$api.post(this.$url.companyRefund.applyRepair, this.form).then(res => {
        if (res) {
          this.cancel();
          this.addEditShow = false;
          this.$message.success("操作成功");
          this.$emit("change", true);
        }
      })
    },
    cancel () {
      this.dialogVisible = false;
      this.refundbaseAmount = 0;
      this.refundGiveAmount = 0;
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.head-img {
  margin: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  .head_avater {
    width: 100%;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid #EEEEEE;
  }
}
.pay-mains {
  padding: 0;
  .member-head {
    border-top: 10px solid @borderColor;
    border-bottom: 10px solid @borderColor;
  }
   /deep/ .el-form-item__content {
        flex: 1;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        .el-form-item__error {
          right: 0;
        }
        p {
          width: 100%;
        }
        .el-input {
          width: 200px;
        }
      }
    .repair-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // height: 60px;
        font-size: 14px;
        padding: 16px;
        border-bottom: 1px solid @borderColor;
        .message {
            
            color: #606266;
        }
    }
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 10px 20px;
      margin-bottom: 0;
    }
    .el-form-item-img {
      border-bottom: 0;
    }

    .el-form-item-update {
      padding: 0 20px;
      height: 46px;
      align-items: center;
      display: flex;
      margin: 0;
      justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      .form-item-right {
        justify-content: flex-end;
        align-items: center;
        .ml10 {
          margin-left: 10px;
        }
      }
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
     
      /deep/ .el-input__inner {
        height: 46px;
      }
      /deep/.el-select .el-input__inner {
        padding: 0 30px;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
    }
    .first-item {
      border-bottom: 10px solid @borderColor;
    }
  }
}
.tips {
  padding: 10px 20px;
  .tips-title {
    margin-bottom: 10px;
  }
}
.infos {
  color: #ff892a;
}
.hint {
  color: #999;
}
.drawer-footer {
   
   .btns_total {
     margin-right: 40px;
   }
  .btns {
    display: flex;
    align-items: center;
  }
}

.member_bg {
  width: 100%;
  height: 56px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .flex-row {
    align-items: center;
    .img {
      width: 30px;
      height: 30px;
    }
  }
}
.member-msg {
      padding: 16px 16px 0;
      .member-border {
        width: 100%;
        background-size: 100% 100%;
        color: white;
        display: flex;
        align-items: center;
        border-radius: 10px;
        padding: 12px 15px;
        background: #3388ff;
        box-sizing: border-box;
        .member-box {
          margin-left: 10px;
          .mobile {
            line-height: 1.6;
            margin-right: 20px;
          }
        }
      }
    }
</style>